// When EDITING (correcting) a saved CDM/OCF/PP review, the BE `validate` endpoint
// rejects with 409 Conflict: it re-runs the patient-eligibility check that only
// `submit` knows how to skip for corrections (submit flips isCorrection=true when
// an originalReimbursementMessageControlId is present). In edit mode that 409 is
// expected and benign — the real correction handling happens in `submit`. So we
// treat validate as passed and let submit proceed.
//
// A review is in edit/correction mode when it carries a
// reimbursementMessageControlId (null on a brand-new review). We only swallow the
// 409 in that case — a 409 on a NEW review is a genuine "not eligible" and must
// still block.
const CONFLICT_STATUS = 409;

export const isCorrectionEligibilityConflict = (error, data) =>
  !!data?.reimbursementMessageControlId &&
  error?.response?.status === CONFLICT_STATUS;
